module.exports = __webpack_public_path__ + "img/weChat.4a6fdca7.jpg";